import { render, staticRenderFns } from "./user_place.vue?vue&type=template&id=44ed4b56&scoped=true&"
import script from "./user_place.vue?vue&type=script&lang=js&"
export * from "./user_place.vue?vue&type=script&lang=js&"
import style0 from "./user_place.vue?vue&type=style&index=0&id=44ed4b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed4b56",
  null
  
)

export default component.exports